import { HeaderWithPolicyTerms } from '@client-info/features/shared/HeaderWithPolicyTerms';
import { useTranslation } from 'react-i18next';
import { useCookiesInfo, useCookiesLabels } from '../../-hooks';
import {
  CookieConsentContainer,
  CookieDescription,
  CookieHeading,
  CookieSubheading,
  CookieTable,
  CookieText,
  FullHeightContainer,
} from '../styled';

const DefaultPolicy = () => {
  const { t } = useTranslation('common');
  const cookies = useCookiesInfo();
  const cookieLabels = useCookiesLabels();

  return (
    <FullHeightContainer component="section">
      <HeaderWithPolicyTerms showLinks={false} />
      <CookieConsentContainer>
        <CookieHeading variant="h4" component="h1">
          {t('cookiepolicy.heading')}
        </CookieHeading>

        <CookieDescription>
          <CookieSubheading>
            {t('cookiepolicy.description.subHeading')}
          </CookieSubheading>
          <CookieText>{t('cookiepolicy.description.text')}</CookieText>
        </CookieDescription>
        <CookieTable>
          <thead>
            <tr>
              <th>{cookieLabels.cookies}</th>
              <th>{cookieLabels.cookieSubgroup}</th>
              <th>{cookieLabels.lifespan}</th>
              <th>{cookieLabels.cookiesUsed}</th>
              <th>{cookieLabels.description}</th>
            </tr>
          </thead>
          <tbody>
            {cookies.map((cookie) => (
              <tr key={cookie.name}>
                <td data-label={cookieLabels.cookies}>{cookie.name}</td>
                <td data-label={cookieLabels.cookieSubgroup}>
                  {cookie.subgroup}
                </td>
                <td data-label={cookieLabels.lifespan}>{cookie.lifespan}</td>
                <td data-label={cookieLabels.cookiesUsed}>
                  {cookie.cookiesUsed}
                </td>
                <td data-label={cookieLabels.description}>
                  {cookie.description}
                </td>
              </tr>
            ))}
          </tbody>
        </CookieTable>
      </CookieConsentContainer>
    </FullHeightContainer>
  );
};

export default DefaultPolicy;
